








import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { env } from '@zyf2e/adapt';
import { mapState } from 'vuex';
import Webview from '@/webview';
import { GLOBAL } from '@/constant';
import { getDirection, getIsLoad } from '@/utils/historyHook';

@Component({
  computed: {
    ...mapState(GLOBAL, ['keepAliveList'])
  }
})
export default class App extends Webview {
  keepAliveList!: string[];

  transitionName = '';

  isBackRoute = 0;

  @Watch('$route')
  watchRoute() {
    if (env.inWechatMiniProgram || getIsLoad()) return;
    this.transitionName = getDirection() ? 'swipe-left' : 'swipe-right';
    // const animation = ['', 'swipe-right', 'swipe-left'];
    // this.transitionName = animation[this.isBackRoute];
    // this.isBackRoute = 2;
  }

  async created() {
    // window.addEventListener('load', () => {
    //   this.isBackRoute = 0;
    // });
    try {
      const hashRouter = window.location.hash ? window.location.hash.split('/') : ['#', 'fast-inquiry-pay'];
      const whiteRouter = [
        '',
        'specialist-detail',
        'doctor-search',
        'department-search',
        'department-specialist',
        'recommend-specialist',
        'group-doctor-list',
        'followed-specialist'
      ];
      if (whiteRouter.includes(hashRouter[1])) {
        await this.pollGetLoaction(true);
      }
    } catch (error) {
      // do nothing
    }
  }
}
